export enum ExecutorRole {
  MENTOR, // Клинер - главный
  WORKER, // Клинер - линейный
  COURIER, // курьер, нужен в групповых уборках
  WORKER_SENIOR, // Клинер - старший
}
